module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (224).c020d9f3.jpg";